<template>
  <v-card v-if="team">
    <h1 class="display-1 px-4 py-4 mb-2 text-center">{{ team.full_name }}</h1>
    <p class="body-1 px-4">City: {{ team.city }}</p>
    <p class="body-1 px-4">State: {{ team.state }}</p>
    <p class="body-1 px-4">Established: {{ team.year_founded }}</p>
    <p class="headline px-4 text-center">Roster</p>
    <v-container fluid v-if="roster.length" class="d-flex flex-wrap justify-space-around">
      <v-card v-for="r in roster" :key="r.PLAYER_ID" width="30%" class="my-2 mx-2" flat>
        <v-card-title class="text-center">{{ r.PLAYER }}</v-card-title>
        <p class="body-1 px-4">Postion: {{ r.POSITION }}</p>
        <p class="body-1 px-4">Number {{ r.NUM }}</p>
      </v-card>
    </v-container>
    <v-container v-else fluid class="d-inline-block text-center" width="100%">
      <v-progress-circular size="100" indeterminate color="blue darken-3"></v-progress-circular>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "TeamInfo",
  props: ["team", "roster"]
};
</script>